export const paths = {
  ggr: '/proekty',
  ggrTile: '/proekty/plitka',
  ggrWallpaper: '/proekty/oboi',
};
